<script setup lang="ts">
import { Link } from '@inertiajs/vue3';

import HarvestTrackerLogo from './HarvestTrackerLogo.vue';

const props = defineProps<{
    mobileAsideOpen: boolean;
    isDesktop: boolean;
}>();
</script>

<template>
    <header v-if="!props.isDesktop" class="sticky top-0 z-50 flex h-14 items-center justify-between gap-2 bg-(--az-light-beige-600) px-4 xl:hidden">
        <Link :href="route('harvest-tracker.home')" class="text-2xl font-semibold text-gray-900" aria-label="AZGFD Harvest Tracker home">
            <HarvestTrackerLogo variant="inline" class="h-11 w-auto text-[#212121]" />
        </Link>

        <div>
            <button type="button" aria-label="Open menu" @click.prevent="$emit('update:mobileAsideOpen', true)">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 12H21" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3 6H21" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3 18H21" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </header>
</template>
